import {replace} from 'react-router-redux'
import {linkFinder} from '../core/links'
import {DEFAULT_TICKET_QUERY, loadTicketStream} from '../ticket/actions'
import TicketStream from '../ticket/components/TicketStream'
import {DEFAULT_CONTACT_QUERY, loadContactStream} from '../provider/actions'
import ContactStream from '../provider/components/ContactStream'
import {DEFAULT_WORKFLOW_QUERY, loadWorkflowStream} from '../workflow/actions'
import WorkflowPanelGroup from '../workflow/components/WorkflowPanelGroup'
import {DEFAULT_OPENING_TICKET_INSTRUCTION_QUERY, loadOpeningTicketInstructionStream} from '../message/actions'
import OpeningTicketInstructionPanelGroup from '../message/components/OpeningTicketInstructionPanelGroup'
import {loadOpeningTicketPurposeRef, loadActivityRef} from '../reference/actions'
import OpeningTicketPurposePanelGroup from '../reference/components/OpeningTicketPurposePanelGroup'
import {
    DEFAULT_CAMPAIGN_QUERY,
    DEFAULT_ANSWER_QUERY,
    loadCampaignStream,
    loadCampaign,
    loadAnswerStream,
} from '../satisfaction/actions'
import CampaignStreamLayout from '../satisfaction/components/CampaignStreamLayout'
import CampaignDetail from '../satisfaction/components/CampaignDetail'
import CampaignDashboard from '../satisfaction/components/CampaignDashboard'
import AnswerStream from '../satisfaction/components/AnswerStream'
import {
    DEFAULT_QUERY,
    DEFAULT_COMPANY_QUERY,
    DEFAULT_AGENCY_QUERY,
    DEFAULT_USER_QUERY,
    loadCompanyStream,
    loadCompany,
    loadUserStream,
    loadAgencyStream,
    loadAgency,
    loadSubsidiaryStream,
} from './actions'
import CompanyLayout from './components/CompanyLayout'
import CompanyStreamLayout from './components/CompanyStreamLayout'
import CompanyDetail from './components/CompanyDetail'
import UserStreamLayout from './components/UserStreamLayout'
import AgencyStreamLayout from './components/AgencyStreamLayout'
import SubsidiaryStream from './components/SubsidiaryStream'
import OrganisationLayout from './components/OrganisationLayout'
import AgencyDetail from './components/AgencyDetail'
import CompanyDashboard from './components/CompanyDashboard'
import AgencyDashboard from './components/AgencyDashboard'
import NotificationsLayout from '../notifications/NotificationsLayout'
import ShowDocumentsPage from '../ticket/components/ShowDocumentsPage'
import CriteriaRef from '../qualificationCriteria/QualificationCriteriaRef'
import ContextualComment from '../contextualcomment/ContextualComment'
import QualificationCriteriaTree from '../qualificationCriteria/QualificationCriteriaTree'

function enterCompanyStream(getState) {
    return (dispatch, params) => {
        const state = getState()
        const {criteria} = state.company

        return dispatch(loadCompanyStream({...DEFAULT_COMPANY_QUERY, ...criteria}))
    }
}

function enterOrganisationRoot(getState, rootPath) {
    return (dispatch) => {
        const state = getState()
        const {authenticated} = state.user

        if (authenticated.company) {
            return dispatch(replace(rootPath + '/' + authenticated.company.uid))
        }
        return dispatch(Promise.reject({statusCode: 403}))
    }
}

function enterCompany(getState) {
    return (dispatch, params) => {
        const state = getState()
        const _appLinks = state.app._links

        return Promise.all([
            dispatch(loadCompany(params.id)),
            // dashboard
            _appLinks.find(linkFinder('tickets')) && dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, clientCompany: params.id, range: {offset: 0, limit: 0}}))
        ])
    }
}

function enterAgency(getState) {
    return (dispatch, params) => {
        const state = getState()
        const _appLinks = state.app._links

        return Promise.all([
            dispatch(loadAgency(params.id, params.aid)),
            // dashboard
            _appLinks.find(linkFinder('tickets')) && dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, agency: params.aid, range: {offset: 0, limit: 0}}))
        ])
    }
}

function enterAgencyStream(getState) {
    return (dispatch, params) => {
        const state = getState()
        const criteria = state.company.agency.criteria

        return dispatch(loadAgencyStream({...DEFAULT_AGENCY_QUERY, ...criteria, companyUid: params.id}))
    }
}

function enterUserStream(getState) {
    return (dispatch, params) => {
        const state = getState()
        const criteria = state.company.user.criteria

        return dispatch(loadUserStream({...DEFAULT_USER_QUERY, ...criteria, companyUid: params.id}))
    }
}

function enterWorkflowPanelGroup(dispatch, params) {
    return Promise.all([
        dispatch(loadWorkflowStream(params.id)),
        dispatch(loadOpeningTicketPurposeRef(params.id))
    ])
}

function enterOpeningTicketInstructionPanelGroup(dispatch, params) {
    return Promise.all([
        dispatch(loadOpeningTicketInstructionStream(params.id, DEFAULT_OPENING_TICKET_INSTRUCTION_QUERY)),
        dispatch(loadOpeningTicketPurposeRef(params.id))
    ])
}

function enterOpeningTicketPurposePanelGroup(dispatch, params) {
    return Promise.all([
        dispatch(loadOpeningTicketPurposeRef(params.id)),
        dispatch(loadActivityRef())
    ])
}

function enterCampaign(dispatch, params) {
    return Promise.all([
        dispatch(loadCampaign(params.id, params.cid)),
        dispatch(loadCompany(params.id))
    ])    
}

function childRoutes(dispatcher, getState) {
    return [{
        path: ':id',
        component: CompanyDetail,
        onEnter: dispatcher(enterCompany(getState)),
        indexRoute: {
            component: CompanyDashboard,
        },
        childRoutes: [{
            path: 'subsidiaries',
            component: SubsidiaryStream,
            onEnter: dispatcher((d, p) => d(loadSubsidiaryStream({...DEFAULT_QUERY, holdingUid: p.id}))),
        }, {
            path: 'users',
            component: UserStreamLayout,
            onEnter: dispatcher(enterUserStream(getState)),
        }, {
            path: 'agencies',
            component: AgencyStreamLayout,
            onEnter: dispatcher(enterAgencyStream(getState)),
        }, {
            path: 'tickets',
            component: TicketStream,
            onEnter: dispatcher((d, p) => d(loadTicketStream({...DEFAULT_TICKET_QUERY, clientCompany: p.id}))),
        }, {
            path: 'documents',
            component: ShowDocumentsPage,
        }, {
            path: 'providercontacts',
            component: ContactStream,
            onEnter: dispatcher((d, p) => d(loadContactStream({...DEFAULT_CONTACT_QUERY, companyUid: p.id}))),
        }, {
            path: 'workflows',
            component: WorkflowPanelGroup,
            onEnter: dispatcher(enterWorkflowPanelGroup),
        }, {
            path: 'notifications',
            component: NotificationsLayout,
        }, {
            path: 'criteriaref',
            component: CriteriaRef,
        }, {
            path: 'contextualcommentref',
            component: ContextualComment,
        }, {
            path: 'criteriatrees',
            component: QualificationCriteriaTree,
        }, {
            path: 'openingticketinstructions',
            component: OpeningTicketInstructionPanelGroup,
            onEnter: dispatcher(enterOpeningTicketInstructionPanelGroup),
        }, {
            path: 'openingticketpurposeref',
            component: OpeningTicketPurposePanelGroup,
            onEnter: dispatcher(enterOpeningTicketPurposePanelGroup),
        }, {
            path: 'satisfactioncampaigns',
            component: CampaignStreamLayout,
            onEnter: dispatcher((d, p) => d(loadCampaignStream({...DEFAULT_CAMPAIGN_QUERY, companyUid: p.id}))),
        }],
    }, {
        path: ':id/agencies/:aid',
        component: AgencyDetail,
        onEnter: dispatcher(enterAgency(getState)),
        indexRoute: {
            component: AgencyDashboard,
        },
        childRoutes: [{
            path: 'tickets',
            component: TicketStream,
            onEnter: dispatcher((d, p) => d(loadTicketStream({...DEFAULT_TICKET_QUERY, agency: p.aid}))),
        }, {
            path: 'providercontacts',
            component: ContactStream,
            onEnter: dispatcher((d, p) => d(loadContactStream({...DEFAULT_CONTACT_QUERY, agencyUids: p.aid}))),
        }, {
            path: 'documents',
            component: ShowDocumentsPage,
        }],
    }, {
        path: ':id/satisfactioncampaigns/:cid',
        component: CampaignDetail,
        onEnter: dispatcher(enterCampaign),
        indexRoute: {
            component: CampaignDashboard,
        },
        childRoutes: [{
            path: 'answers',
            component: AnswerStream,
            onEnter: dispatcher((d, p) => d(loadAnswerStream({
                ...DEFAULT_ANSWER_QUERY,
                companyUid: p.id,
                campaignUid: p.cid,
            }))),
        }],
    }]
}

export function organisationRoute(rootPath, dispatcher, {getState}) {
    return {
        path: rootPath,
        component: OrganisationLayout,
        indexRoute: {
            onEnter: dispatcher(enterOrganisationRoot(getState, rootPath)),
        },
        childRoutes: childRoutes(dispatcher, getState),
    }
}

export default function (rootPath, dispatcher, {getState}) {

    return {
        path: rootPath,
        component: CompanyLayout,
        onEnter: dispatcher(enterCompanyStream(getState)),
        indexRoute: {
            component: CompanyStreamLayout
        },
        childRoutes: childRoutes(dispatcher, getState)
    }
}


// WEBPACK FOOTER //
// ./lib/company/routes.js